import { render } from "./MenuFixture.vue?vue&type=template&id=22e83658&scoped=true"
import script from "./MenuFixture.vue?vue&type=script&lang=js"
export * from "./MenuFixture.vue?vue&type=script&lang=js"

import "./MenuFixture.vue?vue&type=style&index=0&id=22e83658&scoped=true&lang=css"

import exportComponent from "C:\\Users\\HS\\Desktop\\fikstur\\my_fiksture\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e83658"]])

export default __exports__